<template>
  <div class="main2-content">
    <div class="panel-content">
      <div style="text-align: right; position: relative">
        <div>
          了解更多详情，请下载企业社会责任报告
          <span style="margin-left: 50px"></span>
        </div>
        <div>
          For more details, please download the SAIC VOLKSWAGEN CSR Report 2022
          <span style="margin-left: 50px"></span>
        </div>
        <div style="position: absolute; top: 10px; right: 0px; width: 16px">
          <a
            href="./上汽大众2022年度企业社会责任报告.pdf"
            download="上汽大众2022年度企业社会责任报告"
          >
            <img
              :src="require('../../assets/csr/imgs/iconDown@2x.png')"
              style="width: 16px; cursor: pointer"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config1";
export default {
  components: {},
  data() {
    return {};
  },
  beforeMount() {},
  mounted() {},
  methods: {
    download() {
      window.open("./上汽大众2022年度企业社会责任报告.pdf", "_target");
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./common.less");
// 描述字体颜色
@fontValue: #0077c8;

.main2-content {
  color: @fontValue;
  // background-image: url("../../assets/csr/imgs/BGtu10@2x.png");
  // height: 80px;
}
.panel-content {
  // padding: 20px;
}
</style>
